/* eslint-disable eqeqeq */
import React, { useRef } from "react";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { Button } from "../../components/ui/button";
import { useReactToPrint } from "react-to-print";
import {
  formatAccountNumber,
  formatBSBNumber,
  formatedAddress,
  formatedInternationalAddress,
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import moment from "moment";
import { useOrganization } from "../../lib/context/OrganisationContext";
// import LogoSVG from "../../components/LogoSVG";

const PreviewInvoice = ({
  showView,
  setShowView,
  data,
  popupType = "",
  value = "",
  printShow = true,
}) => {
  const printRef = useRef(null);
  const { organizationData } = useOrganization();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    contentRef: printRef,
    documentTitle: `Invoice-${data?.invoice_number}`,
    removeAfterPrint: false, // Optional: prevents issues with disappearing modals
  });

  const InvoiceTemplate = (data) => {
    return data?.file_type === "1" ? (
      <div className="text-xs w-full">
        {/* HEADER */}
        <table className="w-full border-collapse">
          <tbody>
            <tr>
              <td className="align-top w-[33.33%]">
                <div className="font-bold text-sm">INVOICE</div>
                <>
                  <div className="font-bold text-sm">To:</div>
                  <div>
                    {data?.contact
                      ? formatSubcontractorName(data?.contact)
                      : ""}
                  </div>
                  {data?.contact?.international_address ? (
                    <>
                      <div>
                        {formatedInternationalAddress(
                          data?.contact?.full_address,
                          data?.contact?.country?.name
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div>{data?.contact?.street}</div>
                      <div>
                        {formatedAddress(
                          "",
                          data?.contact?.suburb?.name,
                          data?.contact?.state?.short_name,
                          data?.contact?.postal_code
                        )}
                      </div>
                    </>
                  )}
                </>
              </td>
              <td className="align-top w-[33.33%]">
                <div className="mt-10">
                  <div>
                    {data?.trust?.organization
                      ? data?.trust?.organization?.business_name
                        ? data?.trust?.organization?.business_name
                        : data?.trust?.organization?.first_name
                        ? data?.trust?.organization?.first_name +
                          " " +
                          data?.trust?.organization?.last_name
                        : data?.trust?.organization?.last_name
                      : "-"}
                  </div>
                  <div>{data?.trust?.organization?.street}</div>
                  <div>
                    {formatedAddress(
                      "",
                      data?.trust?.organization?.suburb?.name,
                      data?.trust?.organization?.state?.short_name,
                      data?.trust?.organization?.postal_code
                    )}
                  </div>
                  {data?.trust?.organization?.abn && (
                    <div>
                      <span className="font-semibold">ABN:</span>{" "}
                      {data?.trust?.organization?.abn}
                    </div>
                  )}
                </div>
              </td>
              <td className="align-top text-right w-[33.33%]">
                <div className="flex items-end w-full justify-end">
                  {data?.trust?.organization?.logo && (
                    <img
                      src={data?.trust?.organization?.logo}
                      alt="Organization Logo"
                      className="h-14 mb-2"
                    />
                  )}
                </div>
                <>
                  <div>
                    <span className="font-semibold">Invoice Date:</span>{" "}
                    {data?.date
                      ? moment(data?.date, "YYYY-MM-DD").format("DD-MM-YYYY")
                      : moment().format("DD-MM-YYYY")}
                  </div>
                  <div>
                    <span className="font-semibold">Invoice Due Date:</span>{" "}
                    {data?.due_date
                      ? moment(data?.due_date, "YYYY-MM-DD").format(
                          "DD-MM-YYYY"
                        )
                      : moment().format("DD-MM-YYYY")}
                  </div>
                  <div>
                    <span className="font-semibold">Invoice Number:</span>{" "}
                    {data?.invoice_number}
                  </div>
                </>
              </td>
            </tr>
            {/* <tr>
              <td className="align-top w-1/2">
                <div>
                  {data?.trust?.organization
                    ? data?.trust?.organization?.business_name
                      ? data?.trust?.organization?.business_name
                      : data?.trust?.organization?.first_name
                      ? data?.trust?.organization?.first_name +
                        " " +
                        data?.trust?.organization?.last_name
                      : data?.trust?.organization?.last_name
                    : "-"}
                </div>
                <div>{data?.trust?.organization?.street}</div>
                <div>
                  {formatedAddress(
                    "",
                    data?.trust?.organization?.suburb?.name,
                    data?.trust?.organization?.state?.short_name,
                    data?.trust?.organization?.postal_code
                  )}
                </div>
                {data?.trust?.organization?.abn && (
                  <div>
                    <span className="font-semibold">ABN:</span>{" "}
                    {data?.trust?.organization?.abn}
                  </div>
                )}
              </td>
              <td className="align-top w-1/2 text-right">
                <div>
                  <span className="font-semibold">Invoice Date:</span>{" "}
                  {data?.date
                    ? moment(data?.date, "YYYY-MM-DD").format("DD-MM-YYYY")
                    : moment().format("DD-MM-YYYY")}
                </div>
                <div>
                  <span className="font-semibold">Invoice Due Date:</span>{" "}
                  {data?.due_date
                    ? moment(data?.due_date, "YYYY-MM-DD").format("DD-MM-YYYY")
                    : moment().format("DD-MM-YYYY")}
                </div>
                <div>
                  <span className="font-semibold">Invoice Number:</span>{" "}
                  {data?.invoice_number}
                </div>
                <br />
                <div>
                  {data?.contact ? formatSubcontractorName(data?.contact) : ""}
                </div>
                <div>{data?.contact?.street}</div>
                <div>
                  {formatedAddress(
                    "",
                    data?.contact?.suburb?.name,
                    data?.contact?.state?.short_name,
                    data?.contact?.postal_code
                  )}
                </div>
              </td>
            </tr> */}
          </tbody>
        </table>

        {/* ITEM TABLE */}
        <table className="w-full border-none  border-collapse mt-4 text-xs">
          <thead>
            <tr className="border-b  font-bold">
              <td className="p-2">{`${getModuleNamingBySlug(
                organizationData?.organizationData,
                "sub-assets",
                "Sub Asset"
              )}`}</td>
              <td className="p-2">Description</td>
              <td className="p-2 text-right">
                {data?.amount_tax_type == "0"
                  ? "Hammer Price (Ex)"
                  : "Hammer Price (Inc)"}
              </td>
              {Number(
                data?.invoice_items
                  ?.flatMap((itemData) => itemData)
                  ?.reduce(
                    (sum, item) =>
                      sum +
                      Number(
                        `${
                          item?.processing_fee_amount
                            ? item?.processing_fee_amount
                            : 0
                        }`.replace(/,/g, "")
                      ),
                    0
                  )
                  .toFixed(2)
              ) ? (
                <td className="p-2 text-right">Fees</td>
              ) : (
                <></>
              )}
              {Number(
                data?.invoice_items
                  ?.flatMap((itemData) => itemData)
                  ?.reduce(
                    (sum, item) =>
                      sum +
                      Number(
                        `${
                          item?.premium_amount ? item?.premium_amount : 0
                        }`.replace(/,/g, "")
                      ),
                    0
                  )
                  .toFixed(2)
              ) ? (
                <td className="p-2 text-right">Buyer's Premium</td>
              ) : (
                <></>
              )}
              {Number(
                data?.invoice_items
                  ?.flatMap((itemData) => itemData)
                  ?.reduce(
                    (sum, item) =>
                      sum +
                      Number(
                        `${
                          item?.premium_amount ? item?.premium_amount : 0
                        }`.replace(/,/g, "")
                      ),
                    0
                  )
                  .toFixed(2)
              ) ||
              Number(
                data?.invoice_items
                  ?.flatMap((itemData) => itemData)
                  ?.reduce(
                    (sum, item) =>
                      sum +
                      Number(
                        `${
                          item?.processing_fee_amount
                            ? item?.processing_fee_amount
                            : 0
                        }`.replace(/,/g, "")
                      ),
                    0
                  )
                  .toFixed(2)
              ) ? (
                <td className="p-2 text-right">Sub Total</td>
              ) : (
                <></>
              )}
              {Number(
                data?.invoice_items
                  ?.flatMap((itemData) => itemData)
                  ?.reduce(
                    (sum, item) =>
                      sum +
                      Number(
                        `${
                          item?.discount_amount ? item?.discount_amount : 0
                        }`.replace(/,/g, "")
                      ),
                    0
                  )
                  .toFixed(2)
              ) ? (
                <td className="p-2 text-right">Discount</td>
              ) : (
                <></>
              )}
              <td className="p-2 text-right">Amount (Ex)</td>
              <td className="p-2 text-right">Tax</td>
              <td className="p-2 text-right">Net Amount (Inc)</td>
            </tr>
          </thead>
          <tbody>
            {data?.invoice_items?.map((item, idx) => (
              <tr key={idx} className="border-b ">
                <td className="p-2">{item.sub_asset?.name}</td>
                <td className="p-2">{item.description}</td>
                <td className="p-2 text-right">
                  ${formatNumber(Number(item.total_amount))}
                </td>
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.processing_fee_amount
                              ? item?.processing_fee_amount
                              : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <td className="p-2 text-right">
                    ${formatNumber(Number(item.processing_fee_amount))}
                  </td>
                ) : (
                  <></>
                )}
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.premium_amount ? item?.premium_amount : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <td className="p-2 text-right">
                    ${formatNumber(Number(item.premium_amount))}
                  </td>
                ) : (
                  <></>
                )}
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.premium_amount ? item?.premium_amount : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ||
                Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.processing_fee_amount
                              ? item?.processing_fee_amount
                              : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <td className="p-2 text-right">
                    $
                    {formatNumber(
                      Number(
                        Number(
                          Number(item.total_amount) +
                            Number(
                              item.premium_amount ? item.premium_amount : 0
                            ) +
                            Number(
                              item.processing_fee_amount
                                ? item.processing_fee_amount
                                : 0
                            )
                        ).toFixed(2)
                      )
                    )}
                  </td>
                ) : (
                  <></>
                )}
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.discount_amount ? item?.discount_amount : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <td className="p-2 text-right">
                    ${formatNumber(Number(item.discount_amount))}
                  </td>
                ) : (
                  <></>
                )}
                <td className="p-2 text-right">
                  ${formatNumber(Number(item.amount))}
                </td>
                <td className="p-2 text-right">
                  ${formatNumber(Number(item.gst_amount))}
                </td>
                <td className="p-2 text-right">
                  ${formatNumber(Number(item.net_amount))}
                </td>
              </tr>
            ))}
            {/* <tr className="font-bold bg-gray-100">
              <td className="p-2 text-right" colSpan={2}>
                Total
              </td>
              <td className="p-2 text-right">
                ${formatNumber(Number(data?.subtotal_amount))}
              </td>
              {Number(
                data?.invoice_items
                  ?.flatMap((itemData) => itemData)
                  ?.reduce(
                    (sum, item) =>
                      sum +
                      Number(
                        `${
                          item?.processing_fee_amount
                            ? item?.processing_fee_amount
                            : 0
                        }`.replace(/,/g, "")
                      ),
                    0
                  )
                  .toFixed(2)
              ) ? (
                <td className="p-2 text-right">
                  {" "}
                  ${formatNumber(Number(data?.total_processing_fee_amount))}
                </td>
              ) : (
                <></>
              )}
              {Number(
                data?.invoice_items
                  ?.flatMap((itemData) => itemData)
                  ?.reduce(
                    (sum, item) =>
                      sum +
                      Number(
                        `${
                          item?.premium_amount ? item?.premium_amount : 0
                        }`.replace(/,/g, "")
                      ),
                    0
                  )
                  .toFixed(2)
              ) ? (
                <td className="p-2 text-right">
                  {" "}
                  ${formatNumber(Number(data?.total_premium_amount))}
                </td>
              ) : (
                <></>
              )}
              {Number(
                data?.invoice_items
                  ?.flatMap((itemData) => itemData)
                  ?.reduce(
                    (sum, item) =>
                      sum +
                      Number(
                        `${
                          item?.premium_amount ? item?.premium_amount : 0
                        }`.replace(/,/g, "")
                      ),
                    0
                  )
                  .toFixed(2)
              ) ||
              Number(
                data?.invoice_items
                  ?.flatMap((itemData) => itemData)
                  ?.reduce(
                    (sum, item) =>
                      sum +
                      Number(
                        `${
                          item?.processing_fee_amount
                            ? item?.processing_fee_amount
                            : 0
                        }`.replace(/,/g, "")
                      ),
                    0
                  )
                  .toFixed(2)
              ) ? (
                <td className="p-2 text-right">
                  $
                  {formatNumber(
                    Number(
                      Number(
                        data?.subtotal_amount +
                          data?.total_premium_amount +
                          data?.total_processing_fee_amount
                      ).toFixed(2)
                    )
                  )}
                </td>
              ) : (
                <></>
              )}
              {Number(
                data?.invoice_items
                  ?.flatMap((itemData) => itemData)
                  ?.reduce(
                    (sum, item) =>
                      sum +
                      Number(
                        `${
                          item?.discount_amount ? item?.discount_amount : 0
                        }`.replace(/,/g, "")
                      ),
                    0
                  )
                  .toFixed(2)
              ) ? (
                <td className="p-2 text-right">
                  ${formatNumber(Number(data?.total_discount_amount))}
                </td>
              ) : (
                <></>
              )}
              <td className="p-2 text-right">
                ${formatNumber(Number(data?.total_amount))}
              </td>
              <td className="p-2 text-right">
                ${formatNumber(Number(data?.total_gst_amount))}
              </td>
              <td className="p-2 text-right">
                ${formatNumber(Number(data?.total_net_amount))}
              </td>
            </tr> */}
          </tbody>
        </table>

        {/* TOTALS SECTION */}
        <table className="w-full mt-4">
          <tbody>
            <tr>
              <td className="w-3/5 align-top">
                <table className="w-3/5 text-xs">
                  <tbody>
                    <tr>
                      <td className="text-left">Bank Name:</td>
                      <td className="text-left">
                        {data?.trust?.bank
                          ? data?.trust?.bank?.abbreviation +
                            "-" +
                            data?.trust?.bank?.name
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-left">Bank Account Name:</td>
                      <td className="text-left">
                        {data?.trust?.account_name
                          ? data?.trust?.account_name
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-left">BSB:</td>
                      <td className="text-left">
                        {data?.trust?.bsb
                          ? formatBSBNumber(data?.trust?.bsb)
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-left">Account Number:</td>
                      <td className="text-left">
                        {data?.trust?.account_number
                          ? formatAccountNumber(data?.trust?.account_number)
                          : "-"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td className="w-2/5">
                <table className="w-full text-xs">
                  <tbody>
                    <tr>
                      <td className="text-right">
                        {" "}
                        Total{" "}
                        {data?.amount_tax_type == "0"
                          ? "Hammer Price (Ex)"
                          : "Hammer Price (Inc)"}
                      </td>
                      <td className="text-right">
                        ${formatNumber(Number(data?.subtotal_amount))}
                      </td>
                    </tr>
                    {Number(data?.total_processing_fee_amount) ? (
                      <tr>
                        <td className="text-right"> Total Processing Fees</td>
                        <td className="text-right">
                          $
                          {formatNumber(
                            Number(data?.total_processing_fee_amount)
                          )}
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                    {Number(data?.total_premium_amount) ? (
                      <tr>
                        <td className="text-right"> Total Buyer's Premium</td>
                        <td className="text-right">
                          ${formatNumber(Number(data?.total_premium_amount))}
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                    {Number(data?.total_premium_amount) ? (
                      <tr>
                        <td className="text-right"> Sub Total</td>
                        <td className="text-right">
                          $
                          {formatNumber(
                            Number(
                              Number(
                                data?.subtotal_amount +
                                  data?.total_premium_amount +
                                  data?.total_processing_fee_amount
                              ).toFixed(2)
                            )
                          )}
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                    {Number(data?.total_discount_amount) ? (
                      <tr>
                        <td className="text-right"> Total Discount</td>
                        <td className="text-right">
                          ${formatNumber(Number(data?.total_discount_amount))}
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                    <tr>
                      <td className="text-right"> Total Amount (Ex)</td>
                      <td className="text-right">
                        ${formatNumber(Number(data?.total_amount))}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right"> Total Tax</td>
                      <td className="text-right">
                        ${formatNumber(Number(data?.total_gst_amount))}
                      </td>
                    </tr>

                    <tr className="font-bold">
                      <td className="text-right">Total Net Amount (Inc)</td>
                      <td className="text-right">
                        ${formatNumber(Number(data?.total_net_amount))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

        {/* FOOTER */}
        {/* <div className="mt-4">
          <div>
            <span className="font-semibold">Due Date:</span>{" "}
            {data?.due_date
              ? moment(data?.due_date, "YYYY-MM-DD").format("DD-MM-YYYY")
              : ""}
          </div>
          <div className="mt-1">
            When paying by cheque, please complete this payment advice, detach
            and post to the address provided.
          </div>
        </div> */}
      </div>
    ) : (
      <div className="text-xs w-full">
        <div className="border border-black p-4">
          {/* Header */}
          <div className="flex justify-between mb-3">
            <div>
              <strong>
                {data?.trust?.organization
                  ? data?.trust?.organization?.business_name
                    ? data?.trust?.organization?.business_name
                    : data?.trust?.organization?.first_name
                    ? data?.trust?.organization?.first_name +
                      " " +
                      data?.trust?.organization?.last_name
                    : data?.trust?.organization?.last_name
                  : "-"}
              </strong>
              <div>{data?.trust?.organization?.street}</div>
              <div>
                {formatedAddress(
                  "",
                  data?.trust?.organization?.suburb?.name,
                  data?.trust?.organization?.state?.short_name,
                  data?.trust?.organization?.postal_code
                )}
              </div>
              {data?.trust?.organization?.abn && (
                <div>
                  <span className="font-semibold">ABN:</span>{" "}
                  {data?.trust?.organization?.abn}
                </div>
              )}
            </div>
            <div className="text-right">
              <div className="flex items-end w-full justify-end">
                {data?.trust?.organization?.logo && (
                  <img
                    src={data?.trust?.organization?.logo}
                    alt="Organization Logo"
                    className="h-14 mb-2"
                  />
                )}
              </div>
              <strong>INVOICE</strong>
            </div>
          </div>

          <hr className="border-black" />

          {/* Address + Invoice Box */}
          <div className="flex justify-between my-4">
            <div className="w-[49%] border border-black p-2">
              {data?.contact ? formatSubcontractorName(data?.contact) : ""}
              {data?.contact?.international_address ? (
                <>
                  <div>
                    {formatedInternationalAddress(
                      data?.contact?.full_address,
                      data?.contact?.country?.name
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div>{data?.contact?.street}</div>
                  <div>
                    {formatedAddress(
                      "",
                      data?.contact?.suburb?.name,
                      data?.contact?.state?.short_name,
                      data?.contact?.postal_code
                    )}
                  </div>
                </>
              )}
            </div>
            <div className="w-[49%] border border-black p-2">
              <strong>Invoice Details</strong>
              <br />
              Invoice No.: <b>{data?.invoice_number}</b>
              <br />
              Invoice Date:{" "}
              <b>
                {data?.date
                  ? moment(data?.date, "YYYY-MM-DD").format("DD-MM-YYYY")
                  : moment().format("DD-MM-YYYY")}
              </b>
              <br />
              Invoice Due Date:{" "}
              <b>
                {data?.due_date
                  ? moment(data?.due_date, "YYYY-MM-DD").format("DD-MM-YYYY")
                  : moment().format("DD-MM-YYYY")}
              </b>
            </div>
          </div>

          {/* Table */}
          <table className="w-full border border-black border-collapse text-left">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-black p-1">{`${getModuleNamingBySlug(
                  organizationData?.organizationData,
                  "sub-assets",
                  "Sub Asset"
                )}`}</th>
                <th className="border border-black p-1">Description</th>
                <th className="border border-black p-1 text-right">
                  {data?.amount_tax_type == "0"
                    ? "Hammer Price (Ex)"
                    : "Hammer Price (Inc)"}
                </th>
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.processing_fee_amount
                              ? item?.processing_fee_amount
                              : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <th className="border border-black p-1 text-right">Fees</th>
                ) : (
                  <></>
                )}
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.premium_amount ? item?.premium_amount : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <th className="border border-black p-1 text-right">
                    Buyer's Premium
                  </th>
                ) : (
                  <></>
                )}
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.premium_amount ? item?.premium_amount : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ||
                Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.processing_amount
                              ? item?.processing_amount
                              : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <th className="border border-black p-1 text-right">
                    Sub Total
                  </th>
                ) : (
                  <></>
                )}
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.discount_amount ? item?.discount_amount : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <th className="border border-black p-1 text-right">
                    Discount
                  </th>
                ) : (
                  <></>
                )}
                <th className="border border-black p-1 text-right">
                  Amount (Ex)
                </th>
                <th className="border border-black p-1 text-right">Tax</th>
                <th className="border border-black p-1 text-right">
                  Net Amount (Inc)
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.invoice_items?.map((item, idx) => (
                <tr key={idx}>
                  <td className="border border-black p-1">
                    {item.sub_asset?.name}
                  </td>
                  <td className="border border-black p-1">
                    {item.description}
                  </td>
                  <td className="border border-black p-1 text-right">
                    ${formatNumber(Number(item.total_amount))}
                  </td>
                  {Number(
                    data?.invoice_items
                      ?.flatMap((itemData) => itemData)
                      ?.reduce(
                        (sum, item) =>
                          sum +
                          Number(
                            `${
                              item?.processing_fee_amount
                                ? item?.processing_fee_amount
                                : 0
                            }`.replace(/,/g, "")
                          ),
                        0
                      )
                      .toFixed(2)
                  ) ? (
                    <td className="border border-black p-1 text-right">
                      ${formatNumber(Number(item.processing_fee_amount))}
                    </td>
                  ) : (
                    <></>
                  )}

                  {Number(
                    data?.invoice_items
                      ?.flatMap((itemData) => itemData)
                      ?.reduce(
                        (sum, item) =>
                          sum +
                          Number(
                            `${
                              item?.premium_amount ? item?.premium_amount : 0
                            }`.replace(/,/g, "")
                          ),
                        0
                      )
                      .toFixed(2)
                  ) ? (
                    <td className="border border-black p-1 text-right">
                      ${formatNumber(Number(item.premium_amount))}
                    </td>
                  ) : (
                    <></>
                  )}
                  {Number(
                    data?.invoice_items
                      ?.flatMap((itemData) => itemData)
                      ?.reduce(
                        (sum, item) =>
                          sum +
                          Number(
                            `${
                              item?.premium_amount ? item?.premium_amount : 0
                            }`.replace(/,/g, "")
                          ),
                        0
                      )
                      .toFixed(2)
                  ) ||
                  Number(
                    data?.invoice_items
                      ?.flatMap((itemData) => itemData)
                      ?.reduce(
                        (sum, item) =>
                          sum +
                          Number(
                            `${
                              item?.processing_fee_amount
                                ? item?.processing_fee_amount
                                : 0
                            }`.replace(/,/g, "")
                          ),
                        0
                      )
                      .toFixed(2)
                  ) ? (
                    <td className="border border-black p-1 text-right">
                      $
                      {formatNumber(
                        Number(
                          Number(
                            Number(item.total_amount) +
                              Number(
                                item.premium_amount ? item.premium_amount : 0
                              ) +
                              Number(
                                item.processing_fee_amount
                                  ? item.processing_fee_amount
                                  : 0
                              )
                          ).toFixed(2)
                        )
                      )}
                    </td>
                  ) : (
                    <></>
                  )}
                  {Number(
                    data?.invoice_items
                      ?.flatMap((itemData) => itemData)
                      ?.reduce(
                        (sum, item) =>
                          sum +
                          Number(
                            `${
                              item?.discount_amount ? item?.discount_amount : 0
                            }`.replace(/,/g, "")
                          ),
                        0
                      )
                      .toFixed(2)
                  ) ? (
                    <td className="border border-black p-1 text-right">
                      ${formatNumber(Number(item.discount_amount))}
                    </td>
                  ) : (
                    <></>
                  )}
                  <td className="border border-black p-1 text-right">
                    ${formatNumber(Number(item.amount))}
                  </td>
                  <td className="border border-black p-1 text-right">
                    ${formatNumber(Number(item.gst_amount))}
                  </td>
                  <td className="border border-black p-1 text-right">
                    ${formatNumber(Number(item.net_amount))}
                  </td>
                </tr>
              ))}
              {/* <tr className="font-bold bg-gray-100">
                <td className="border border-black p-1 text-right" colSpan={2}>
                  Total
                </td>
                <td className="border border-black p-1 text-right">
                  ${formatNumber(Number(data?.subtotal_amount))}
                </td>
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.processing_fee_amount
                              ? item?.processing_fee_amount
                              : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <td className="border border-black p-1 text-right">
                    {" "}
                    ${formatNumber(Number(data?.total_processing_fee_amount))}
                  </td>
                ) : (
                  <></>
                )}

                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.premium_amount ? item?.premium_amount : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <td className="border border-black p-1 text-right">
                    {" "}
                    ${formatNumber(Number(data?.total_premium_amount))}
                  </td>
                ) : (
                  <></>
                )}
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.premium_amount ? item?.premium_amount : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ||
                Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.processing_fee_amount
                              ? item?.processing_fee_amount
                              : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <td className="border border-black p-1 text-right">
                    $
                    {formatNumber(
                      Number(
                        Number(
                          data?.subtotal_amount +
                            data?.total_premium_amount +
                            data?.total_processing_fee_amount
                        ).toFixed(2)
                      )
                    )}
                  </td>
                ) : (
                  <></>
                )}
                {Number(
                  data?.invoice_items
                    ?.flatMap((itemData) => itemData)
                    ?.reduce(
                      (sum, item) =>
                        sum +
                        Number(
                          `${
                            item?.discount_amount ? item?.discount_amount : 0
                          }`.replace(/,/g, "")
                        ),
                      0
                    )
                    .toFixed(2)
                ) ? (
                  <td className="border border-black p-1 text-right">
                    ${formatNumber(Number(data?.total_discount_amount))}
                  </td>
                ) : (
                  <></>
                )}
                <td className="border border-black p-1 text-right">
                  ${formatNumber(Number(data?.total_amount))}
                </td>
                <td className="border border-black p-1 text-right">
                  ${formatNumber(Number(data?.total_gst_amount))}
                </td>
                <td className="border border-black p-1 text-right">
                  ${formatNumber(Number(data?.total_net_amount))}
                </td>
              </tr> */}
            </tbody>
          </table>

          {/* TOTALS SECTION */}
          <table className="w-full mt-4">
            <tbody>
              <tr>
                <td className="w-3/5 align-top">
                  <table className="w-3/5 text-xs">
                    <tbody>
                      <tr>
                        <td className="text-left">Bank Name:</td>
                        <td className="text-left">
                          {data?.trust?.bank
                            ? data?.trust?.bank?.abbreviation +
                              "-" +
                              data?.trust?.bank?.name
                            : "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-left">Bank Account Name:</td>
                        <td className="text-left">
                          {data?.trust?.account_name
                            ? data?.trust?.account_name
                            : "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-left">BSB:</td>
                        <td className="text-left">
                          {data?.trust?.bsb
                            ? formatBSBNumber(data?.trust?.bsb)
                            : "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-left">Account Number:</td>
                        <td className="text-left">
                          {data?.trust?.account_number
                            ? formatAccountNumber(data?.trust?.account_number)
                            : "-"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td className="w-2/5">
                  <table className="w-full text-xs">
                    <tbody>
                      <tr>
                        <td className="text-right">
                          {" "}
                          Total{" "}
                          {data?.amount_tax_type == "0"
                            ? "Hammer Price (Ex)"
                            : "Hammer Price (Inc)"}
                        </td>
                        <td className="text-right">
                          ${formatNumber(Number(data?.subtotal_amount))}
                        </td>
                      </tr>
                      {Number(data?.total_processing_fee_amount) ? (
                        <tr>
                          <td className="text-right"> Total Processing Fees</td>
                          <td className="text-right">
                            $
                            {formatNumber(
                              Number(data?.total_processing_fee_amount)
                            )}
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                      {Number(data?.total_premium_amount) ? (
                        <tr>
                          <td className="text-right"> Total Buyer's Premium</td>
                          <td className="text-right">
                            ${formatNumber(Number(data?.total_premium_amount))}
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                      {Number(data?.total_premium_amount) ? (
                        <tr>
                          <td className="text-right"> Sub Total</td>
                          <td className="text-right">
                            $
                            {formatNumber(
                              Number(
                                Number(
                                  data?.subtotal_amount +
                                    data?.total_premium_amount +
                                    data?.total_processing_fee_amount
                                ).toFixed(2)
                              )
                            )}
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                      {Number(data?.total_discount_amount) ? (
                        <tr>
                          <td className="text-right"> Total Discount</td>
                          <td className="text-right">
                            ${formatNumber(Number(data?.total_discount_amount))}
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                      <tr>
                        <td className="text-right"> Total Amount (Ex)</td>
                        <td className="text-right">
                          ${formatNumber(Number(data?.total_amount))}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-right"> Total Tax</td>
                        <td className="text-right">
                          ${formatNumber(Number(data?.total_gst_amount))}
                        </td>
                      </tr>

                      <tr className="font-bold">
                        <td className="text-right">Total Net Amount (Inc)</td>
                        <td className="text-right">
                          ${formatNumber(Number(data?.total_net_amount))}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <ResponsiveDrawerForm
      title="Preview Invoice"
      open={showView}
      setOpen={setShowView}
      read
      popupType={popupType}
      className="md:w-[65vw]"
    >
      <>
        <div className="p-0 max-h-[80vh] overflow-y-auto">
          <div className="rounded-md border">
            <div
              ref={printRef}
              className="bg-white text-black p-4 max-w-4xl mx-auto text-sm m-0 relative"
            >
              {/* Watermark (hidden on screen, visible on print) */}
              {/* <div className=" print:flex absolute inset-0 items-center justify-center">
                <LogoSVG
                  className={`w-[400px] opacity-10 rotate-[-30deg] pointer-events-none`}
                  resolvedColor={resolvedColor}
                />
              </div> */}
              {InvoiceTemplate(data)}
            </div>
          </div>
        </div>
        {/* 👇 Print Button */}
        {printShow && (
          <div className="mt-4 flex justify-end">
            <Button onClick={handlePrint}>Print</Button>
          </div>
        )}
      </>
    </ResponsiveDrawerForm>
  );
};

export default PreviewInvoice;
